import React from "react";

const CommonReportLayout = ({
  title,
  filters,
  onShow,
  children
}) => {
  return (
    <div className="container-fluid mt-3">

      {/* FILTER CARD */}
      <div className="card p-3 mb-3">
        <div className="row">
          {filters}
          <div className="col-md-2 mt-4">
            <button className="btn btn-success w-100" onClick={onShow}>
              Show
            </button>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="card p-3">
        {children}
      </div>

    </div>
  );
};

export default CommonReportLayout;